export type ItemPresentationType = 'start' | 'end' | 'intermediary'

interface RankedItem {
  summaryRankString: string
  itineraryRankString: string
}

/** For use with array sort method */
export function bySummaryRank(a: RankedItem, b: RankedItem): number {
  if (a.summaryRankString === b.summaryRankString) {
    return 0
  }
  return a.summaryRankString < b.summaryRankString ? -1 : 1
}

/** For use with array sort method */
export function byItineraryRank(a: RankedItem, b: RankedItem): number {
  if (a.itineraryRankString === b.itineraryRankString) {
    return 0
  }
  return a.itineraryRankString < b.itineraryRankString ? -1 : 1
}
